<template>
    <div class="box">
        <div class="header">
            <div class="filter">
                <ul class="filter-box">
                    <li>
                        <span>{{ $t('cloudEditor.OutputTask.filter.nameLike') }}</span>
                        <Input
                            v-model="filter.nameLike"
                            class="selector"
                            size="small"
                            clearable
                            :placeholder="$t('Message.placeholder')"
                        />
                    </li>
                </ul>
            </div>
        </div>
        <div ref="list" class="content">
            <table class="list">
                <thead>
                <td width="50">{{ $t('cloudEditor.OutputTask.list.id') }}</td>
                <td>{{ $t('cloudEditor.OutputTask.list.outputTaskName') }}</td>
                <td>{{ $t('cloudEditor.OutputTask.list.roomTitle') }}</td>
                <td>{{ $t('cloudEditor.OutputTask.list.status.title') }}</td>
                <td>{{ $t('cloudEditor.OutputTask.list.createDatetime') }}</td>
                <td>{{ $t('cloudEditor.OutputTask.list.userName') }}</td>
                <td :width="isCordova()?50:350">{{ $t('cloudEditor.OutputTask.list.operation') }}</td>
                </thead>

                <tr v-for="i in list" :key="i.id">
                    <td>{{i.id}}</td>
                    <td>{{i.outputTaskName}}</td>
                    <td>{{ i.roomTitle }}</td>
                    <td v-if="i.status == 0">{{ $t('cloudEditor.OutputTask.list.status.queuing') }}</td>
                    <td v-else-if="i.status == 1">{{ $t('cloudEditor.OutputTask.list.status.starting') }}</td>
                    <td v-else-if="i.status == 2">{{ $t('cloudEditor.OutputTask.list.status.pause') }}</td>
                    <td v-else-if="i.status == 3">{{ $t('cloudEditor.OutputTask.list.status.transcoding') }}{{ i.finishRate }}%</td>
                    <td v-else-if="i.status == 4">{{ $t('cloudEditor.OutputTask.list.status.done') }}</td>
                    <td v-else-if="i.status == 5">{{ $t('cloudEditor.OutputTask.list.status.stop') }}</td>
                    <td v-else>{{ $t('cloudEditor.OutputTask.list.status.error') }}</td>
                    <td>{{ i.createDatetime }}</td>
                    <td>{{ i.userName }}</td>
                    <td>
                        <Button
                            v-if="i.status < 4"
                            type="dashed"
                            icon="md-radio-button-on"
                            @click="stopTask(i.id, i.outputTaskName)"
                        >{{ $t('Button.stop') }}</Button>
                    </td>
                </tr>
            </table>

            <Spin v-show="loading" fix class="spin">
                <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
                <div>Loading</div>
            </Spin>
            <Page
                    class="pager"
                    :total="pagination.total"
                    :current="pagination.page"
                    :page-size="pagination.pageSize"
                    @on-change="v=>pagination.page=v"
                    @on-page-size-change="v=>pagination.pageSize=v"
                    show-elevator
                    show-sizer
            />
        </div>
    </div>
</template>

<script>
    import api from "@/api/Api";
    import extend from "extend";
    export default {
        props: ['id'],
        data(){
            return {
                loading: true,
                dialog: false,
                dialog_loading: false,
                list: []
            }
        },
        computed: {
            filter: {
                get() {
                    return this.$store.state.views.cloudEditor.outputTask.filter;
                },
                set(v) {
                    this.$store.commit("views/cloudEditor.outputTask.filter", v);
                }
            },
            pagination: {
                get() {
                    return this.$store.state.views.cloudEditor.outputTask.pagination;
                },
                set(v) {
                    this.$store.commit("views/cloudEditor.outputTask.pagination", v);
                }
            }
        },
        watch: {
            'filter.nameLike'() {
                this.pagination.page = 1;
                this.refresh();
            },
            "pagination.page": "refresh",
            "pagination.pageSize": "refresh"
        },
        methods: {
            async stopTask(id, title){
                if (!confirm(this.$t('cloudEditor.OutputTask.message.stopTask.confirm') + `(${title}) ?`)) return;

                this.loading = true;

                try {
                    let ret = await api.call("cloudEditor/stopOutputTask", {
                        id: id
                    });

                    let successMsg = this.$t('cloudEditor.OutputTask.message.stopTask.success').replace(/title/, title);
                    this.$Notice.success({ title: successMsg });

                    this.refresh();
                } catch (e) {
                    let errorMsg = this.$t('cloudEditor.OutputTask.message.stopTask.error').replace(/title/, title);
                    this.$Notice.error({ title: errorMsg, desc: e.resultMsg });
                }
                this.loading = false;
            },
            async refresh() {
                this.loading = true;
                this.filter.taskId = this.id;
                try {
                    let ret = await api.call(
                        "cloudEditor/outputList",
                        extend(true, {}, this.pagination, this.filter)
                    );

                    this.list = ret.list;
                    this.list = this.list.map(i => {
                        i.finishRate = 0;
                        return i;
                    });

                    this.pagination.total = ret.total;
                } catch (e) {}

                this.loading = false;
            },
            //更新状态
            async refreshStatus() {
                try {
                    let ids = this.list.map(i => i.id);

                    if (!ids.length) return;

                    let ret = await api.call("cloudEditor/refreshData", { ids });

                    let needRefresh = false;
                    this.list = this.list.map(i => {
                        //在返回的列表里面搜索对应的 id
                        let found = ret.list.filter(j => j.id == i.id)[0];
                        if (found) {
                            if (
                                (i.status == 1 &&
                                    found.status != 1) ||
                                (i.status != 4 &&
                                    found.status == 4)
                            ) {
                                needRefresh = true;
                            }

                            //更新 status
                            i.status = found.status;
                            i.finishRate = found.finishRate;
                        }
                        return i;
                    });
                    needRefresh && this.refresh(true);
                } catch (e) {}
            }
        },
        mounted() {
            this.refresh();
            this._statusTmr = setInterval(this.refreshStatus, 2000);
        },
        created() {},
        beforeDestroy() {
            clearInterval(this._statusTmr);
        }
    }
</script>

<style lang="less" scoped>
    @keyframes spin1 {
        from {
            transform: rotate(0deg);
        }
        50% {
            transform: rotate(180deg);
        }
        to {
            transform: rotate(360deg);
        }
    }
    .box {
    }
    .header {
        & > * {
            margin-bottom: 10px;
            border-radius: 5px;
        }
        .toolbar {
            height: 32px;
            line-height: 32px;

            button {
                margin-right: 22px;
                vertical-align: middle;
            }

            .search {
                width: 200px;
            }
        }
        .filter {
            padding: 10px 20px;
            background: #fff;

            .filter-box {
                list-style: none;
                display: inline-block;
                & > li {
                    display: inline-block;
                    margin-right: 20px;
                }
            }
        }
    }
    .content {
        position: relative;
        border-radius: 5px;
        background: white;
        padding: 0 20px;

        .spin {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
        }
    }
    .list {
        width: 100%;
        border-radius: 5px;
        border-collapse: collapse; /*表格的边框合并，如果相邻，则共用一个边框*/
        border-spacing: 0; /*设置行与单元格边框的间距。当表格边框独立（即border-collapse:separate;）此属性才起作用*/

        td {
            padding: 12px 0;
            border-bottom: 1px solid #e9e9e8;
        }
    }
    .pager {
        text-align: center;
        padding: 10px;
    }

    .selector {
        display: inline-block;
        width: auto;
    }
</style>